import styled from '@emotion/styled';
import { To, useNavigate } from '@trinity/chat-components/containers/Chat/RoutingProvider';
import { forwardRef, memo } from 'react';

export const StyledAnchor = styled.a(({ theme }) => ({
  color: theme.palette.hyperlink,
  textDecoration: 'underline',
}));

export type LinkProps = {
  replace?: boolean;
  to: To;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>;

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, onClick, children, replace, ...otherProps }, ref) => {
    const navigate = useNavigate();
    const toStr = typeof to === 'string' ? to : to.pathname + (to.search || '') + (to.hash || '');

    const isExternal = /^https?:\/\//i.test(toStr);

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
      // Allow modifier clicks (cmd/ctrl/shift + click)
      if (
        event.metaKey ||
        event.ctrlKey ||
        event.altKey ||
        event.shiftKey ||
        event.button !== 0
      ) {
        return;
      }

      onClick?.(event);

      if (!isExternal && typeof to === 'string') {
        event.preventDefault();
        navigate(to, { replace });
      }
    };

    return (
      <a
        ref={ref}
        {...otherProps}
        href={toStr}
        onClick={handleClick}
        {...(isExternal
          ? { target: "_blank", rel: "noopener noreferrer" }
          : {})}
      >
        {children}
      </a>
    );
  }
);

export const StyledLink = memo((props: LinkProps) => {
  return (
    <Link
      style={{
        color: '#1271c4',
        textDecoration: 'underline',
      }}
      {...props} />
  );
});